import {
    START_FACTOR_REPORT,
    SET_FACTOR_SCENARIOS,
    SET_FACTOR_VISIBLE,
    SET_FACTOR_LOADING_SCENARIOS,
} from "../Actions/Types";
import { IMobilyticsScenarioLite } from "../Models/IMobilyticsScenarioLite";

declare const scout;

export interface IFactorState {
    loadingScenarios: boolean;
    isFactorModalVisible: boolean;
    scenarios: IMobilyticsScenarioLite[];// TODO
}

export const defaultState: IFactorState = {
    loadingScenarios: true,
    isFactorModalVisible: false,
    scenarios: [],
};

export const factorReducer = (
    state: IFactorState = { ...defaultState },
    action
): IFactorState => {
    switch (action.type) {
        /** misc */
        case START_FACTOR_REPORT: {
            scout.interop.api.factorSubmission.toggleFactorFormIsVisible(
                true
            );
            return {
                ...state,
                isFactorModalVisible: true,
            };
        }
        case SET_FACTOR_SCENARIOS: {
            return {
                ...state,
                scenarios: action.data,
                loadingScenarios: false,
            };
        }
        case SET_FACTOR_VISIBLE: {
            return {
                ...state,
                isFactorModalVisible: action.data,
            };
        }
        case SET_FACTOR_LOADING_SCENARIOS: {
            return {
                ...state,
                loadingScenarios: action.data,
            };
        }

        default:
            return state;
    }
};
